<template>
  <div class="module-filter">
    <div
      v-for="item in options"
      :key="item.value"
      :class="['module-filter-item', item.value === active ? 'active' : '']"
      @click="onSelect(item.value)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "device",
      options: [
        { label: "设备巡检", value: "device" },
        { label: "Server巡检", value: "server" }
      ]
    };
  },
  methods: {
    onSelect(value) {
      if (value === this.active) {
        return;
      }
      this.active = value;
      this.$emit("change", value);
    }
  }
};
</script>

<style lang="scss">
.module-filter {
  display: flex;
  flex-direction: row;
  margin: 8px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #efeff4;

  .module-filter-item {
    flex: 1;
    text-align: center;
    font-size: 14px;
    line-height: 36px;
    color: #333;
    background-color: #f7f7f8;

    &.active {
      color: #fff;
      background-color: #4682b4;
    }
  }
}
</style>